export default __webpack_public_path__ + "static/media/bobike50000.1acc43d0.jpg";